import React from "react";
import { useTranslation } from "components/translations/useTranslation";
import OneButtonModalFooter from "components/modals/OneButtonModalFooter";
import { MODAL_CONTENT_TAB_INDEX } from "utils/constants";
import { CostUnitWarningItem, CostUnitWarningProps } from "types/modals";

const CostUnitWarning = ({
    more,
    closeModal,
    loopFocus,
    initialFocusRef,
}: CostUnitWarningProps): React.ReactElement => {
    const { translate } = useTranslation();
    const warnings = more?.warnings ?? [];

    return (
        <>
            <div className="ga-modal__content">
                <div id="warning-grid">
                    <div className="list-group px-0" id="warning-grid-title">
                        <div className="list-group-item list-group-title">
                            <div className="row mx-0">
                                <div className="col-md-6">
                                    {translate("popUp.costUnitWarning.costUnit")}
                                </div>
                                <div className="col-md-6">
                                    {translate("popUp.costUnitWarning.warning")}
                                </div>
                            </div>
                        </div>

                        {warnings.map((item: CostUnitWarningItem, index: number) => {
                            const costUnit = `${item.dimensionName} (${item.dimensionNumber}): ${item.number} (${item.name})`;
                            return (
                                <div className="list-group-item" key={index}>
                                    <div className="row mx-0">
                                        <div className="col-md-6">{costUnit}</div>
                                        <div className="col-md-6 warning">
                                            {translate("popUp.costUnitWarning.noLongerAvailable")}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <OneButtonModalFooter
                tabIndex={MODAL_CONTENT_TAB_INDEX}
                enabled={true}
                callback={closeModal}
                text={translate("popUp.close")}
                loopFocus={loopFocus}
                buttonRef={initialFocusRef}
            />
        </>
    );
};

export default CostUnitWarning;
